import { ParameterType } from '@/study-search/enums';

import { IIndexation } from '../../../interfaces';
import { FilterKey } from '@studyportals/search-filters/server-side';
import { Filter } from '../Filter';

export class CampaignTypeFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.CAMPAIGN_TYPE, ParameterType.CAMPAIGN_TYPE, []);
	}
	public canBeIndexed(): boolean {
		return false;
	}
}
